import React, { Component } from 'react'

export default class WorksConfineDellaLuce extends Component {
  render() {
    return (
 <div class="modal" id="worksconfinedellaluce" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-full" role="document">
        <div class="modal-content">
          <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
            <div class="modal-header">
                <h5 class="modal-title"><strong>&quot;SUL CONFINE DELLA LUCE.&quot; </strong> <em>Ediz. PeQuod 2025 <br /> (distribuzione: Messaggerie. Codice: 9788860683861)</em></h5>
            </div>
            <div class="modal-body p-4" id="result">
                   

            <div align="left">

<table border="0"  cellpadding="20">
  <tr colspan="1" width="100%">
  </tr>
  <tr width="100%">

<td width="50%">


<br/> <br/>

        
<div className="desc">
										<p>Cosa scatta nella mente di un uomo quando scopre che sta per perdere la vista?
										Ad Arrigo, un fotoreporter che ha seguito le proprie passioni senza mai voltarsi indietro, resta poco tempo per fare i conti col passato. Deve incontrare la compagna spagnola da cui si è allontanato anni prima. Vuole a ogni costo ritrovare la figlia che da allora si rifiuta di vederlo. Col sostegno di un giovane nipote si mette in viaggio, e ha inizio un’avventura dall’esito imprevedibile. La ricerca diventa indagine, poi frenetica corsa contro il tempo nello scenario andaluso. </p>
										<p>Un finale inatteso dirà che niente era come sembrava, e che il viaggio dovrà varcare un nuovo confine per giungere a termine.
										</p>
									</div>
<br/>

<strong>ne hanno scritto:</strong> <br/><br/>

<ul>
<li><a href="rec/confinedellaluce/adige-articolo.pdf" target="_blank" >Luigi Longhi, quotidiano l’Adige, 5/3/2025</a></li>
<li>Gaia Matteini, quotidiano Corriere Romagna, 16/3/2025</li>
<li><a href="rec/confinedellaluce/il_t.pdf" target="_blank" >Caro Martinelli, quotidiano il T, 8/3/2025</a></li>
<li><a href="rec/confinedellaluce/avvenire.pdf" target="_blank" >Roberto Carnero, quotidiano Avvenire, 14/5/2025</a></li>
<li><a href="rec/confinedellaluce/tuttolibri.png" target="_blank" >Sergio Pent, Tuttolibri, inserto del quotidiano La Stampa, 3/5/2025</a></li>
<li>Augusto Goio, settimanale Vita Trentina, 8/6/2025</li>
<li><a href="https://www.raiplaysound.it/audio/2025/07/Fahrenheit-del-16072025-bb962868-0a85-43da-9a58-88f9ebd872e5.html" target="_blank" rel="noopener noreferrer">Intervista per “Il libro del giorno” nel programma Fahrenheit di RAI Radio 3, 16/7/2025</a></li>
</ul>
<br/>


</td>


</tr>

</table>
</div>















            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
        </div>
    </div>
</div>


    )
  }
}
